import {
  Institution,
  InstitutionsForOccupationOptions,
  SchoolDetails
} from '@cpd-app/core-module/models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const institutionFeatureKey = 'institution';

export interface InstitutionState extends EntityState<Institution> {
  institutionsForOccupationOptions: InstitutionsForOccupationOptions;
  selectedInstitutionId: string;
  selectedInstitutionDetails: SchoolDetails;
  error: any;
  loading: boolean;
  institutionsByProgram: Institution[];
  /**
   * OC-2. The size of the whole matched set, which is not the number of
   * entities held: the store now holds one page. The pager is drawn from this.
   */
  institutionsTotalCount: number;
}

export const institutionStateAdapter: EntityAdapter<Institution> =
  createEntityAdapter<Institution>({
    selectId: (institution: Institution) => institution.schoolId,
    sortComparer: false
  });

export const initialInstitutionState: InstitutionState =
  institutionStateAdapter.getInitialState({
    institutionsForOccupationOptions: {
      edLevelId: null,
      cipCodeCutoff: 7,
      useOnlineFilter: null,
      useOpenAdmissionFilter: null,
      useTaApprovedFilter: null,
      useRegAccredFilter: false,
      // OC-2. The page the list opens on. Matches the sibling Programs list,
      // which has always shown five at a time, scaled up for a table the
      // member scans rather than a short recommendation list.
      limit: 25,
      offset: 0,
      // OCC.5. No credential chosen until step 2 says otherwise.
      schoolProgramId: null
    } as InstitutionsForOccupationOptions,
    selectedInstitutionId: null,
    selectedInstitutionDetails: null,
    error: null,
    loading: false,
    institutionsByProgram: [],
    institutionsTotalCount: 0
  });

export const { selectIds, selectEntities, selectAll, selectTotal } =
  institutionStateAdapter.getSelectors();
